<template>
  <primary-confirm-dialog
    v-model="showDialog"
    :loading="closing"
    title="Заказ отредактирован, будет напечатан чек коррекции на кухню"
    confirm-text="Продолжить"
    close-after-loading
    @confirm="closeSession"
    @close="showDialog = false"
  />
</template>

<script>
  import snackbarMessage from '@/mixins/snackbar-message'
  import { mapState } from 'vuex'
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'

  export default {
    name: 'EditSessionDialog',
    components: { PrimaryConfirmDialog },
    mixins: [snackbarMessage],
    computed: {
      ...mapState({
        showCorrectionReceiptDialog: (state) =>
          state.editSession.showCorrectionReceiptDialog,
        closing: (state) => state.editSession.closing,
        nextRoute: (state) => state.editSession.nextRoute,
        orderId: (state) => state.fastOrder.orderId,
      }),
      showDialog: {
        get () {
          return this.showCorrectionReceiptDialog
        },
        set (value) {
          this.$store.commit('editSession/setShowCorrectionReceiptDialog', value)
        },
      },
    },
    methods: {
      closeSession () {
        this.$store
          .dispatch('editSession/close', this.orderId)
          .then(() => {
            this.$store.commit(
              'editSession/setAllowExitWithoutChekingChanges',
              true,
            )
            this.$router.push(this.nextRoute)
          })
          .catch((e) => {
            this.showErrorFromResponse(e)
          })
      },
    },
  }
</script>
